import { ListProps } from "@chakra-ui/react"

import DepositCarouselModalInfoPoints from "#/ui-old/DepositCarousel/DepositCarouselModalInfoPoints"

export default function DepositMigrationInfo({ ...props }: ListProps) {
  const depositMigrationInfoPoints = [
    "Migrations are handled first-come, first-serve, when liquidity is available.",
    "Migration will take between 7-14 days.",
    "During the migration period, you will continue earning mats, unless your deposit expires.",
    "Withdrawing won’t be available while migrating.",
    "You will be able to extend your deposit.",
  ]

  return (
    <DepositCarouselModalInfoPoints
      infoPoints={depositMigrationInfoPoints}
      {...props}
    />
  )
}
